module.exports = __webpack_public_path__ + "static/media/OmeJan.b1f889bf.jpg";